import { observer } from "mobx-react";
import currentPortalStore from "../../../../../../../stores/current-portal-store";
import PolicyStore from "../../../../../stores/policy-store";
import { FEATURES } from "../../../../../../../models/Plan";
import { RELEASE_ABLE_RESOLUTIONS_IDS, RESOLUTION_ID } from "../../../../../../resolutions/constants";
import { SelectDropdown } from "../../../../../../../components/inputs/select-dropdown/select-dropdown";
import { FormFieldLine } from "../../../../../../../components/form-field-line/form-field-line";
import FontBody2 from "../../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../../../components/fonts/font-props";
import { processTypeOptionsList } from "../../../../../constants";
import ListLayout from "../../../../../../../components/layouts/list-layout/list-layout";
import ExchangeTriggerSettings from "../process-trigger-settings/exchange-trigger-settings/exchange-trigger-settings";
import "./exchange-process.scss";
import { IValidationGroup } from "../../../../../../../hooks/validation-group/validation-group-hook";

interface IProps {
    policy: PolicyStore;
    validationGroup: IValidationGroup;
}

const ExchangeProcess: React.FC<IProps> = observer(({ policy, validationGroup }) => {
    const autoExchangeAllowed = currentPortalStore.isFeatureAllowed(FEATURES.AUTO_EXCHANGE);
    const selectedIsAutoExchangeOption = processTypeOptionsList().find(o => o.value === (policy.isAutoExchange ? 1 : 0));

    return (
        <>
            {(autoExchangeAllowed && policy.selectedResolutionId && RELEASE_ABLE_RESOLUTIONS_IDS.includes(policy.selectedResolutionId)) &&
                <>
                    <FormFieldLine
                        label='Exchange Process'
                        note='Automate to release exchanges automatically when triggered.'
                        tooltip={<div className="exchange-process-tooltip">
                            <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                            If any of the items in the exchange order have been set to be released manually, <br/>
                            then all items will need to be manually released.
                            </FontBody2>
                        </div>}
                    >

                        <ListLayout>
                            <SelectDropdown
                                value={selectedIsAutoExchangeOption}
                                options={processTypeOptionsList()}
                                onChange={(v) => policy.setIsAutoExchange(!!v?.value)}
                                isSearchable={false}
                            />

                            {!!policy.isAutoExchange && <ExchangeTriggerSettings policy={policy} validationGroup={validationGroup} />}
                        </ListLayout>
                    </FormFieldLine>
                </>
            }

            {(!autoExchangeAllowed && policy.selectedResolutionId === RESOLUTION_ID.INSTANT_VARIANT_EXCHANGE) &&
                <>
                    <FormFieldLine
                        label='Exchange Process'
                        note='Automate to release exchanges automatically when triggered.'
                        disabled={true}
                        tooltip={<FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>Sorry, this feature is not included<br /> in your subscription plan</FontBody2>}
                    >
                        <SelectDropdown
                            value={selectedIsAutoExchangeOption}
                            options={processTypeOptionsList()}
                            onChange={(v) => policy.setIsAutoExchange(!!v?.value)}
                            disabled={true}
                            isSearchable={false}
                        />
                    </FormFieldLine>
                </>
            }
        </>
    );
});

export default ExchangeProcess;